import React, { useEffect, useRef, useState } from 'react'
import { Avatar, Button, Card, Col, Divider, Input, Row } from 'antd';
import {
  MessageOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import '../../styles/pages/chat/Chat.css'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/store';
import { fetchChatUsers } from '../../redux/actions/chat/Chat';
import ChatUsersList from '../../components/chat/ChatUsersList';
import ChatConversacionesList from '../../components/chat/Conversaciones/ChatConversacionesList';
import Conversacion from '../../components/chat/Conversaciones/Conversacion';
import { fetchChatConversaciones } from '../../redux/actions/chat/conversaciones/Conversaciones';

type Contact = {
  id: number;
  name: string;
  avatar: string;
  status: string;
  role: string;
  lastMessage?: string;
  lastMessageTime?: string;
};

type Message = {
  id: number;
  text: string;
  time: string;
  isMe: boolean;
  isRead: boolean;
};

const Chat = () => {

  const dispatch = useDispatch<AppDispatch>();

  const { chat_users, loading, pagination } = useSelector((state: RootState) => state.chat);
  const {
    conversacion_seleccionada
  } = useSelector((state: RootState) => state.conversaciones);

  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const isFirstRender = useRef(true);

  const getData = () => {
    dispatch(fetchChatUsers(pagination.page, pagination.limit));
  }

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search)
    }, 1500);

    return () => clearTimeout(handler)
  }, [search]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      return;
    }

    dispatch(fetchChatConversaciones(pagination.page, pagination.limit, debouncedSearch))

  }, [debouncedSearch]);

  useEffect(() => {
    // getData()
  }, [])

  return (
    <Row gutter={[12,12]} className="h-[85vh] bg-white rounded-md">
      <Col xs={24} md={8} className='h-full  border bl-1'>
        <div className="p-4 border-b flex items-center">
          <Input placeholder="Search..." onChange={(e) => setSearch(e.target.value)}
            prefix={
              <SearchOutlined />}
            className="flex-grow"
          />
        </div>

        <Divider className="my-0" />
        <ChatConversacionesList />
      </Col>
      <Col 
        xs={24} md={16} className='h-full relative !p-0'>
        {!conversacion_seleccionada ? (
          <div className="flex flex-col items-center justify-center h-full">
            <div className="bg-blue-100 p-8 rounded-full mb-4">
              <MessageOutlined className="text-4xl text-blue-500" />
            </div>
            <p className="mb-4">Selecciona un contacto para comenzar a conversar.</p>
            <Button type="primary" className='min-w-max'>
              Seleccionar el contacto
            </Button>
          </div>
          ) : (
          <Conversacion />
          )}
      </Col>
    </Row>
  )
}

export default Chat